/**
 * Моковые данные для транзакций робоэдвайзера
 * Используются пока запрос за операциями не доступен
 */
export const mockTrades = [
  {
    id: '1',
    title: 'Покупка акций Сбербанк',
    date: '11.11.25 15:30',
    created_at: '2025-11-11 15:30:00',
    amount: '15000',
    sum: '15000',
    change: '+15 000 ₽',
    type: 'buy',
    type_id: 1,
    description: 'Покупка акций Сбербанк на сумму 15 000 ₽'
  },
  {
    id: '2',
    title: 'Покупка облигаций ОФЗ',
    date: '11.11.25 15:20',
    created_at: '2025-11-11 15:20:00',
    amount: '50000',
    sum: '50000',
    change: '+50 000 ₽',
    type: 'buy',
    type_id: 1,
    description: 'Покупка облигаций ОФЗ на сумму 50 000 ₽'
  },
  {
    id: '3',
    title: 'Продажа акций Газпром',
    date: '11.11.25 15:10',
    created_at: '2025-11-11 15:10:00',
    amount: '25000',
    sum: '25000',
    change: '-25 000 ₽',
    type: 'sell',
    type_id: 2,
    description: 'Продажа акций Газпром на сумму 25 000 ₽'
  },
  {
    id: '4',
    title: 'Комиссия брокера',
    date: '11.11.25 15:05',
    created_at: '2025-11-11 15:05:00',
    amount: '500',
    sum: '500',
    change: '-500 ₽',
    type: 'fee',
    type_id: 3,
    description: 'Комиссия брокера'
  },
  {
    id: '5',
    title: 'Покупка ETF',
    date: '11.11.25 14:50',
    created_at: '2025-11-11 14:50:00',
    amount: '30000',
    sum: '30000',
    change: '+30 000 ₽',
    type: 'buy',
    type_id: 1,
    description: 'Покупка ETF на сумму 30 000 ₽'
  },
  {
    id: '1',
    title: 'Покупка акций Сбербанк',
    date: '11.11.25 15:30',
    created_at: '2025-11-11 15:30:00',
    amount: '15000',
    sum: '15000',
    change: '+15 000 ₽',
    type: 'buy',
    type_id: 1,
    description: 'Покупка акций Сбербанк на сумму 15 000 ₽'
  },
  {
    id: '2',
    title: 'Покупка облигаций ОФЗ',
    date: '11.11.25 15:20',
    created_at: '2025-11-11 15:20:00',
    amount: '50000',
    sum: '50000',
    change: '+50 000 ₽',
    type: 'buy',
    type_id: 1,
    description: 'Покупка облигаций ОФЗ на сумму 50 000 ₽'
  },
  {
    id: '3',
    title: 'Продажа акций Газпром',
    date: '11.11.25 15:10',
    created_at: '2025-11-11 15:10:00',
    amount: '25000',
    sum: '25000',
    change: '-25 000 ₽',
    type: 'sell',
    type_id: 2,
    description: 'Продажа акций Газпром на сумму 25 000 ₽'
  },
  {
    id: '4',
    title: 'Комиссия брокера',
    date: '11.11.25 15:05',
    created_at: '2025-11-11 15:05:00',
    amount: '500',
    sum: '500',
    change: '-500 ₽',
    type: 'fee',
    type_id: 3,
    description: 'Комиссия брокера'
  },
  {
    id: '5',
    title: 'Покупка ETF',
    date: '11.11.25 14:50',
    created_at: '2025-11-11 14:50:00',
    amount: '30000',
    sum: '30000',
    change: '+30 000 ₽',
    type: 'buy',
    type_id: 1,
    description: 'Покупка ETF на сумму 30 000 ₽'
  }
];

